import { useI18n } from '../i18n';
import type { GameSummary } from '../api/types';

const games = [
  {
    key: 'rps',
    url: 'https://rps.gaming.enlightenmentlab.dev/',
    name: ['剪刀石頭布', 'Rock Paper Scissors'],
    description: ['快速配對、邀請朋友、或挑戰 AI，從大廳開始一局。', 'Queue, invite a friend, or challenge AI from the lobby.'],
    modes: ['四種賽制 · 2 人對戰', 'Four formats · 2 players'],
    kind: ['心理博弈', 'Mind game'],
    art: 'rps',
  },
  {
    key: 'gomoku',
    url: 'https://gomoku.gaming.enlightenmentlab.dev/',
    name: ['五子棋', 'Gomoku'],
    description: ['連成五子，與朋友或 AI 對弈。', 'Make five in a row against a friend or AI.'],
    modes: ['雙人對戰 · AI 對弈', 'Two players · AI opponents'],
    kind: ['策略棋盤', 'Strategy board'],
    art: 'gomoku',
  },
  {
    key: 'liars-dice',
    url: 'https://liars-dice.gaming.enlightenmentlab.dev/',
    name: ['吹牛骰子', "Liar's Dice"],
    description: ['猜點、喊價、揭骰，邀請朋友一起較量。', 'Bid, bluff, and challenge your friends.'],
    modes: ['A–I 九種模式 · 2–6 人', 'Nine modes (A–I) · 2–6 players'],
    kind: ['派對骰局', 'Dice table'],
    art: 'dice',
  },
];

function onlineCount(game?: GameSummary): number | null {
  if (!game) return null;
  return game.variants.filter((v) => v.published).reduce((sum, v) => sum + (v.online_players ?? 0), 0);
}

export function StandaloneGames({ rpsGame }: { rpsGame?: GameSummary }) {
  const { locale, t } = useI18n();
  const language = locale === 'en' ? 1 : 0;
  const rpsOnline = onlineCount(rpsGame);

  return (
    <div className="game-grid">
      {games.map((game) => (
        <article className="portal-game-card" key={game.key}>
          <div className={`game-art game-art--${game.art}`} aria-hidden="true">
            {game.art === 'rps' ? (
              <>
                <span>✊</span>
                <span>✋</span>
                <span>✌</span>
              </>
            ) : game.art === 'gomoku' ? (
              <>
                <span />
                <span />
                <span />
                <span />
                <span />
              </>
            ) : (
              <>
                <span>⚂</span>
                <span>⚄</span>
                <span>⚅</span>
              </>
            )}
          </div>

          <div className="stack stack--tight">
            <div className="spread">
              <span className="badge">{game.kind[language]}</span>
              {game.key === 'rps' && rpsOnline !== null ? (
                <span className="badge">
                  <span className="online-dot" aria-hidden="true" />
                  {t('games.online')} {rpsOnline}
                </span>
              ) : null}
            </div>
            <h3 className="game-card__title">{game.name[language]}</h3>
            <p className="muted">{game.description[language]}</p>
            <p className="faint">{game.modes[language]}</p>
          </div>

          <div className="row portal-game-card__actions">
            <a className="btn btn--primary btn--sm" href={game.url}>
              {t('games.play')}
            </a>
          </div>
        </article>
      ))}
    </div>
  );
}
